import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getRegion = async () => {
  const { data } = await axios.get(`${api_base_url}/Region`);
  return data;
};
// Insert New Region
export const addRegion = async (newRegion) => {
  const { data } = await axios.post(`${api_base_url}/Region`, {
    ...newRegion[0],
  });
  return data;
};

//Get REgion By Area
export const getRegionByAreaId = async (areaId) => {
  let areaByTerritoryData;
  const { data } = await axios.get(
    `${api_base_url}/Region/GetRegionByAreaId/${areaId}`
  );
  return data;
};

// Update Region
export const updateRegion = async (updatedRegion) => {
  const { data } = await axios.put(
    `${api_base_url}/Region/${updatedRegion[0].regionId}`,
    updatedRegion[0]
  );
  return data;
};
// Deactivate Region
export const deleteRegion = async (ids) => {
  await axios.delete(`${api_base_url}/Region`, {
    data: ids,
  });
};
